function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M35.47,0h-32A3.43,3.43,0,0,0,0,3.42V26.2a3.42,3.42,0,0,0,3.42,3.42H35.47a3.42,3.42,0,0,0,3.42-3.42V3.42A3.42,3.42,0,0,0,35.47,0ZM35,2.28l-13,13a3.47,3.47,0,0,1-4.9,0L3.9,2.28ZM2.28,25.73V3.88l11,10.88Zm1.61,1.61,11-11,1.39,1.38a4.62,4.62,0,0,0,6.51,0l1.31-1.31L35,27.34Zm32.72-1.61L25.69,14.81,36.61,3.89Z"
})));

function SvgMail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38.89 29.62"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOC44OSAyOS42MiI+PHRpdGxlPjwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBkPSJNMzUuNDcsMGgtMzJBMy40MywzLjQzLDAsMCwwLDAsMy40MlYyNi4yYTMuNDIsMy40MiwwLDAsMCwzLjQyLDMuNDJIMzUuNDdhMy40MiwzLjQyLDAsMCwwLDMuNDItMy40MlYzLjQyQTMuNDIsMy40MiwwLDAsMCwzNS40NywwWk0zNSwyLjI4bC0xMywxM2EzLjQ3LDMuNDcsMCwwLDEtNC45LDBMMy45LDIuMjhaTTIuMjgsMjUuNzNWMy44OGwxMSwxMC44OFptMS42MSwxLjYxLDExLTExLDEuMzksMS4zOGE0LjYyLDQuNjIsMCwwLDAsNi41MSwwbDEuMzEtMS4zMUwzNSwyNy4zNFptMzIuNzItMS42MUwyNS42OSwxNC44MSwzNi42MSwzLjg5WiIvPjwvZz48L2c+PC9zdmc+";
export { SvgMail as ReactComponent };